import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BrowseConfig } from '@core/bean/browse-config';
import { BrowseService } from '@shared/components/browse/browse.service';
import { Router } from '@angular/router';
import { LinkFlowService } from '@shared/components/link-flow/link-flow.service';
import { JyExtendService } from '../../../routes/workflow/new-flow/newFlow.service';
import { DatePipe } from '@angular/common';


export const EXE_COUNTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LinkFlowComponent),
  multi: true,
};


/**
 * 验证码
 */
@Component({
  selector: 'link-flow',
  templateUrl: './link-flow.component.html',
  providers: [EXE_COUNTER_VALUE_ACCESSOR],
  styles: [],
})
export class LinkFlowComponent implements OnInit, ControlValueAccessor {


  constructor(private browseService: BrowseService, private router: Router, private linkFlowService: LinkFlowService, private jyExtendService: JyExtendService, private datePipe: DatePipe) {
  }

  arr = [];
  @Input()
  showDel = false;
  @Input()
  read = false;
  @Input() workflowList = [];

  ngOnInit(): void {
  }

  propagateChange = (_: any) => {
  };

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    this.arr = obj;
  }

  /**
   * 相关流程
   */
  conFig: BrowseConfig = new BrowseConfig('ProcessComponent');
  public haveDone: any = {};//接口请求回来的已办数据
  public list: any = [];//穿梭框中的数据
  public pageNum: number = 0;//页码
  public modalSelectList: any = [];//modal中选中的数据
  public searchData: any = {};//搜索条件
  linkFlowBrowser() {
    // this.conFig.multiple = true;
    // this.browseService.open(this.conFig,F
    //   (result) => {
    //     this.arr = [];
    //     result.forEach(v => {
    //       this.arr.push({
    //         workflowId: v.workflowId,
    //         requestId: v.requestId,
    //         title: v.workflowNodeBase.workflowBase.workflowName,
    //         createdBy: v.name,
    //         createdDate:v.createdDate,
    //       });
    //     });
    //     this.propagateChange(this.arr);
    //   },
    //   () => {
    //   });
    this.pageNum = 0;
    this.searchData = {};
    this.modalSelectList = JSON.parse(JSON.stringify(this.arr));
    this.dealData();
  }

  //请求回来的接口的数据和穿梭框交互
  public selectLinkLoading: boolean = false;

  dealData() {
    this.modalIsVisible = true;
    let workflowQuery = {
      firstResult: this.pageNum,
      maxResult: 10,
      nodeType: '1,2',
      requestId: this.searchData.inputId,
      title: this.searchData.title,
    };
    if (this.workflowList.length > 0) {
      workflowQuery['workflowList'] = this.workflowList;
    }
    this.selectLinkLoading = true;
    this.jyExtendService.getHavedone(workflowQuery).subscribe((data) => {
      this.haveDone = data;
      let haveDoneList = [];
      let haveDoneObj: any = {};
      if (this.modalSelectList) {
        this.modalSelectList.forEach((item) => {
          item.direction = 'right';
          if (!item['flowTitle']) {
            item.flowTitle = item.title;
            item.title = item.flowTitle + '(' + item.createdBy + '创建于' + this.datePipe.transform(item.createdDate, 'yyyy-MM-dd HH:mm:ss') + ')';
          }
          haveDoneList.push(item);
          haveDoneObj[item.requestId] = true;
        });
      }
      data.content.forEach((item) => {
        if (!haveDoneObj[item.requestId]) {
          haveDoneList.push({
            workflowId: item.workflowId,
            requestId: item.requestId,
            title: item.workflowNodeBase.workflowBase.workflowName + '(' + item.name + '创建于' + this.datePipe.transform(item.createdDate, 'yyyy-MM-dd HH:mm:ss') + ')',
            flowTitle: item.workflowNodeBase.workflowBase.workflowName,
            createdBy: item.name,
            createdDate: item.createdDate,
          });
        }
      });
      this.list = haveDoneList;
      this.selectLinkLoading = false;
    }, () => this.selectLinkLoading = false, () => this.selectLinkLoading = false);
  }

  //重置搜索条件
  resetGetData() {
    this.searchData = {};
  }

  //分页器页数改变
  pageNumber(num) {
    this.pageNum = num - 1;
    this.dealData();
  }

  //穿梭框数据穿梭
  change(ret: {}): void {
    if (ret['list']) {
      if (ret['to'] == 'right') {
        ret['list'].forEach((item) => {
          this.modalSelectList.push(item);
        });
      } else {
        for (let i = this.modalSelectList.length - 1; i >= 0; i--) {
          for (let j = 0; j < ret['list']['length']; j++) {
            if (this.modalSelectList[i]) {
              if (ret['list'][j].requestId == this.modalSelectList[i]['requestId']) {
                this.modalSelectList.splice(i, 1);
              }
            }
          }
        }
      }
    }
  }

  /**
   * 删除关联流程
   */
  deleteFlows(id) {
    this.arr.splice(id, 1);
  }

  //点击跳转至流程页
  goFlow(requestId) {
    this.linkFlowService.get(requestId).subscribe((data) => {
      let obj = {
        requestId: requestId,
        iconName: 'anticon anticon-appstore',
        formUrl: data.workflowTemp,
      };
      let paramStr = JSON.stringify(obj);
      window.open('/#/srm-workflow;searchData=' + paramStr);
    });

  }

//  流程弹出框
  public modalIsVisible: boolean = false;

  selectLink() {
    this.arr = [];
    this.modalSelectList.forEach((item) => {
      item.title = item.flowTitle;
      delete item['flowTitle'];
    });
    this.arr = JSON.parse(JSON.stringify(this.modalSelectList));
    this.propagateChange(this.arr);
    this.modalIsVisible = false;
  }

  cancelLink() {
    this.modalIsVisible = false;
  }
}
